<template>
  <nav class="navbar">
    <a class="logo-container" href="https://humo.be">
      <img class="logo" :src="`${baseUrl}/images/logo.svg`" alt="Humo logo" />
    </a>
  </nav>
</template>

<script setup>
const baseUrl = process.env.NODE_ENV === 'production' ? window.location.origin + '/tool' : window.location.origin
</script>
